import gql from 'graphql-tag'

const getSettings = () => gql`
  {
    airports {
      id
      name
      priority
      selected
    }
    partners {
      partnerId
      memberId
    }
  }
`

export { getSettings }
